import { apiDelete, apiGet, apiPatch, apiPost } from "./client";

export type DeskTodo = {
  id: string;
  title: string;
  linkPath: string | null;
  doneAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export function listDeskTodos(
  companyRef: string,
  opts?: { done?: boolean; signal?: AbortSignal },
) {
  const params = new URLSearchParams();
  if (opts?.done) params.set("done", "1");
  const qs = params.toString();
  return apiGet<{ todos: DeskTodo[] }>(
    `/c/${companyRef}/desk/todos${qs ? `?${qs}` : ""}`,
    { signal: opts?.signal },
  );
}

export function createDeskTodo(
  companyRef: string,
  body: { title: string; linkPath?: string | null },
) {
  return apiPost<{ todo: DeskTodo }>(`/c/${companyRef}/desk/todos`, body);
}

export function patchDeskTodo(
  companyRef: string,
  todoId: string,
  body: { title?: string; linkPath?: string | null; done?: boolean },
) {
  return apiPatch<{ todo: DeskTodo }>(
    `/c/${companyRef}/desk/todos/${todoId}`,
    body,
  );
}

export function deleteDeskTodo(companyRef: string, todoId: string) {
  return apiDelete<{ deleted: boolean }>(
    `/c/${companyRef}/desk/todos/${todoId}`,
  );
}
